import { CButton } from "@coreui/react";
import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";

import './Subscription_Check_Modal.css'
import { useNavigate } from "react-router-dom";
import Warning_Lottie from "../../../components/animation/warning_lottie/Warning_Lottie";

const Subscription_Check_Modal = ({ status, show, onHide }) => {

    const navigate = useNavigate()

    return (
        <Modal className="Subscription_Check_Modal" show={show}
            onHide={onHide}
            backdrop="static"     // prevents closing by clicking outside
            keyboard={false}
            centered>
            {/* <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Your Subscription Awaits!
                </Modal.Title>
            </Modal.Header> */}

            <Modal.Body>

                <div className="lottie_holder">
                    <Warning_Lottie />
                </div>

                <p className="label_text">{status !== "new" ? "Your subscription has expired. Please purchase a new plan to continue using the service." : "You don’t have an active subscription. Subscribe now to unlock all features."}</p>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <div className="btn_holder">
                    <button className="buy_btn" onClick={() => { navigate("/buy-subscription"); onHide(true) }}>
                        Buy
                    </button>
                    <button className="cancle_btn" onClick={() => { onHide(true) }}>
                        Cancel
                    </button>
                </div>
            </Modal.Footer>


        </Modal>
    );
};

export default Subscription_Check_Modal;
